import React from 'react';
import { BiCheck } from 'react-icons/bi';
import { Container, Content, CloseModal, Round } from './styles';

import { EXCLUDE_MODAL_ANIMATION } from './animations';

const UpdateUserModal = ({ handleCloseClick, message, hasClose }) => {
  return (
    <Container>
      <Content
        variants={EXCLUDE_MODAL_ANIMATION}
        initial="unMounted"
        animate="mounted"
        exit="unMounted"
      >
        <Round>
          <BiCheck />
        </Round>

        <h1>{message}</h1>

        {hasClose && <CloseModal onClick={handleCloseClick}>Fechar</CloseModal>}
      </Content>
    </Container>
  );
};

export default UpdateUserModal;
